// extracted by mini-css-extract-plugin
export default {"modal":"modal___yafhO","goto1":"goto1___Hi6A4","goto2":"goto2___kM_c9"};